import { Theme, WithStyles } from "@material-ui/core";
import { Link } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import withStyles from "@material-ui/core/styles/withStyles";
import HighlightOff from "@material-ui/icons/DirectionsBike";
import DetailIcon from "@material-ui/icons/AssignmentTurnedIn";
import * as React from "react";
import { Race, RaceState } from "../../api/model";
import { RaceTypeLabels, RaceStateLabels } from "../../EnumsLabels";
import { mockTheme } from "../../utils/utils";
import AsyncTable, { ColumnDefinition } from "../AsyncTable";
import { CSSProperties } from "react";
import NumberFormat from "react-number-format";

const styles = (theme: Theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
  actionButton: {
    margin: 4,
    "&:hover": {
      borderColor: "#ff000088",
      borderStyle: "solid",
      borderWidth: "1px",
      background: "#f00",
    },
  },
});

/**
 *
 * @param state
 */
function getColorState(state: RaceState) {
  let c = "#000000";
  if (state === RaceState.CREATED) {
    c = "#01579b";
  }
  if (state === RaceState.ASSIGNED) {
    c = "#ff9800";
  }
  if (state === RaceState.IN_PROGRESS) {
    c = "#2e7d32";
  }
  const st: CSSProperties = {
    color: c,
    fontWeight: "bold",
  };
  return st;
}

/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

interface RaceListProps extends WithStyles<keyof typeof classesType> {
  data: Race[];
  withDriver?: boolean;
  change?: (id: number) => void;
}

const RaceList = (props: RaceListProps) => {
  const columns: ColumnDefinition[] = [
    {
      path: "id",
      label: "#Pedido",
      draw: (cd, value: Race) => <div># {value.id}</div>,
    },
    {
      path: "owner.user.name",
      label: "Cliente",
    },
    {
      path: "startDate",
      label: "Recibido",
      draw: (cd: ColumnDefinition, value: Race) => {
        return <span>{new Date(value.startDate).toLocaleString("en-GB")}</span>;
      },
    },
    {
      path: "state",
      label: "Estado",
      draw: (cd, value: Race) => (
        <div style={getColorState(value.state)}>
          {RaceStateLabels[value.state]}
        </div>
      ),
    },
    {
      path: "branch.name",
      label: "Sucursal",
    },
    {
      path: "pickDate",
      label: "Inicio Chofer",
      draw: (cd: ColumnDefinition, value: Race) => {
        if (value.pickDate) {
          return (
            <span>{new Date(value.pickDate).toLocaleString("en-GB")}</span>
          );
        }
        return <span>--</span>;
      },
    },
    {
      path: "route.length",
      label: "Distancia",
      draw: (cd: ColumnDefinition, value: Race) => {
        if (value) {
          return (
            <span>
              <NumberFormat
                value={(value.route.length || 0) / 1000}
                suffix={" Km."}
                displayType={"text"}
                decimalScale={1}
              />
            </span>
          );
        }
        return <span>--</span>;
      },
    },
    {
      path: "",
      numeric: false,
      label: "Acciones",
      draw: (cd: ColumnDefinition, data: Race) => {
        return (
          <div>
            <Link to={"/race/" + data.id}>
              <IconButton
                aria-label="Ver detalle"
                title="Ver detalle"
                color="primary"
              >
                <DetailIcon />
              </IconButton>
            </Link>
            <IconButton
              onClick={() => props.change(data.driver.id)}
              disabled={data && !data.driver}
              aria-label="Ver ubicación"
              title="Ver ubicación"
              color="primary"
            >
              <HighlightOff />
            </IconButton>
          </div>
        );
      },
    },
  ];

  if (props.withDriver) {
    columns.splice(2, 0, {
      path: "driver.user.name",
      label: "Chofer",
      draw: (cd: ColumnDefinition, value: Race) => {
        return value.driver ? (
          value.driver && (
            <span>{value.driver.user.name || value.driver.user.email}</span>
          )
        ) : (
          <span>--</span>
        );
      },
    });
  }

  return (
    <AsyncTable
      rowsPage={25}
      title={""}
      wrapInPaper={false}
      showHeader={false}
      columnDefinition={columns}
      data={props.data}
    />
  );
};

export default withStyles(styles as any)(RaceList);



// WEBPACK FOOTER //
// ./src/components/race/RaceListComponent.tsx